module.exports = __webpack_public_path__ + "static/img/head_portrait.b2f892a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head_portrait.jpeg
// module id = 7ki/
// module chunks = 127